import React from "react";
import { Box, Typography, Button } from "@mui/material";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import logger from "../logger";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    logger.error("Unhandled render error caught by ErrorBoundary", {
      error: error?.message,
      stack: error?.stack,
      componentStack: errorInfo?.componentStack,
    });
  }

  handleReload = () => {
    window.location.assign("/");
  };

  render() {
    if (this.state.hasError) {
      return (
        <Box
          dir="rtl"
          display="flex"
          flexDirection="column"
          alignItems="center"
          justifyContent="center"
          minHeight="100vh"
          textAlign="center"
          px={3}
        >
          <ErrorOutlineIcon sx={{ fontSize: 64, color: "#E53935", mb: 2 }} />
          <Typography variant="h5" fontWeight={700} color="#1f2937" mb={1}>
            משהו השתבש
          </Typography>
          <Typography variant="body1" color="#6b7280" mb={3}>
            אירעה שגיאה בלתי צפויה. ניתן לנסות לחזור לדף הבית.
          </Typography>
          <Button
            variant="contained"
            onClick={this.handleReload}
            sx={{ bgcolor: "#0054A5", "&:hover": { bgcolor: "#003d7a" } }}
          >
            חזרה לדף הבית
          </Button>
        </Box>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
